import { render } from "./parts.vue?vue&type=template&id=b7aaa298&scoped=true"
import script from "./parts.vue?vue&type=script&lang=js"
export * from "./parts.vue?vue&type=script&lang=js"

import "./parts.vue?vue&type=style&index=0&id=b7aaa298&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7aaa298"]])

export default __exports__